export const tenantConnections = {
  cannotCreate: "Cannot create Tenant connections",
  pleaseCheckIfDBExists:
    "Please check if database exists before creating the tenant"
};
